"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _Loader = _interopRequireDefault(require("../v1/components/Loader/Loader"));
var _omit = _interopRequireDefault(require("lodash/omit"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import {
//     SelectItemPropTypes,
//     OptgroupPropTypes
// } from './SelectItemPropTypes';

class Select extends _react.Component {
  static defaultProps = {
    iconPosition: 'left'
  };
  state = {
    validationState: null
  };
  _isFirstRender = true;
  componentDidMount() {
    // if a placeholder is present on first render, we want to use this for setting the placeholder class to avoid a flash
    // in the coloring of the placeholder text in the field on initial load
    this._isFirstRender = false;
    this._select.addEventListener('invalid', this._onInvalid);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    this._checkIfDisabledSelected();
  }
  componentWillUnmount() {
    this._select.removeEventListener('invalid', this._onInvalid);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onInvalid
    } = this.props;
    const validationState = evt.currentTarget.validity;
    this.setState({
      validationState
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  _onChange = evt => {
    const {
      items,
      onChange
    } = this.props;
    const selectedItem = items.reduce((options, {
      optgroup,
      ...item
    }) => {
      return optgroup ? [...options, ...optgroup] : [...options, item];
    }, []).find(({
      value
    }) => value === evt.target.value);
    this.setState({
      validationState: null
    });
    if (onChange) {
      onChange(selectedItem);
    }
  };
  _checkIfDisabledSelected() {
    // if a disabled option is selected at first, make it the same color as placeholder as thats typically why its selected
    if ((0, _isEmpty.default)(this._select.value)) {
      _dom.default.addClass(this._select, 'FormElement-item-placeholder');
    } else {
      _dom.default.removeClass(this._select, 'FormElement-item-placeholder');
    }
  }
  _renderOptgroup = ({
    label,
    optgroup
  }) => {
    return /*#__PURE__*/_react.default.createElement("optgroup", {
      key: label,
      label: label
    }, optgroup.map(this._renderItem));
  };
  _renderItem = ({
    disabled = false,
    label = '',
    value = ''
  }, i) => {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: value,
      disabled: disabled
    }, label);
  };

  /**
   * Getter for the select DOM element.
   *
   * @public
   * @returns {Element} - The select element.
   */
  get node() {
    return this._select;
  }
  render() {
    const {
      className,
      name,
      items,
      disabled,
      loading,
      error,
      helpNode,
      label,
      dropdownIcon,
      icon,
      iconPosition,
      required,
      inline,
      defaultValue,
      placeholder,
      onFocus,
      ...attrs
    } = this.props;
    const spreadProps = (0, _omit.default)(attrs, ['onChange', 'onInvalid']);
    const {
      validationState
    } = this.state;
    const isValid = validationState ? validationState.valid : true;
    const containerClasses = (0, _classnames.default)('Select', 'FormElement', {
      'FormElement-inline': inline
    }, {
      'FormElement-with-icon': icon
    }, {
      [`FormElement-with-icon-${iconPosition}`]: icon
    }, {
      'FormElement-contains-error': !isValid
    }, className);
    const itemClasses = (0, _classnames.default)('FormElement-item', {
      'FormElement-item-placeholder': placeholder && !defaultValue && this._isFirstRender
    });
    const customIconClasses = (0, _classnames.default)('Select-dropdown-icon', dropdownIcon ? dropdownIcon.props.className : null);
    const newDefaultValue = placeholder && !defaultValue ? '' : defaultValue;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: containerClasses
    }, label, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control"
    }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
      ref: node => {
        this._select = node;
      },
      className: itemClasses,
      name: name,
      required: required,
      disabled: disabled,
      defaultValue: newDefaultValue,
      onFocus: onFocus,
      onChange: this._onChange
    }, spreadProps), placeholder && /*#__PURE__*/_react.default.createElement("option", {
      value: "",
      disabled: true
    }, placeholder), items.map((item, i) => {
      return item.optgroup ? this._renderOptgroup(item) : this._renderItem(item, i);
    })), loading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      size: 16,
      borderWidth: 2
    }) : dropdownIcon ? (/*#__PURE__*/(0, _react.cloneElement)(dropdownIcon, {
      className: customIconClasses
    })) : /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      className: "Select-dropdown-icon"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "Select-icon"
    }, icon)), helpNode && /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-help-text"
    }, helpNode), !isValid && error);
  }
}
exports.default = Select;